// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jhdn","importantInfo":"styles_importantInfo__lW5lc"};